// ===================================== ===================================== 1
  gsap.set('.co-gifting-1 .z-ani-o', { opacity: 0, y: 20 });
  let cPS1Tl1 = gsap.timeline();
  cPS1Tl1.to('.co-gifting-1 .z-ani-o', {
    y: 0,
    opacity: 1,
    duration: 0.75,
    stagger: 0.1,
    ease: "power2.inOut"
  });
gsap.to('.co-gifting-1-right-frame img', { 
  scrollTrigger: {
    start: 'top top',
    end: 'bottom top',
    trigger: 'body',
    endTrigger: '.co-gifting-1',
    scrub: true
  },
  top: "-10%"
 });
// ===================================== ===================================== 3
gsap.set('.co-gifting-3 .z-ani-o', { opacity: 0, y: 20 });
gsap.to('.co-gifting-3 .z-ani-o', { 
  scrollTrigger: {
    start: 'top 95%',
    end: 'bottom top',
    trigger: '.co-gifting-3-grid'
  },
  y: 0,
  opacity: 1,
  duration: 0.75,
  stagger: 0.1,
  ease: "power2.inOut"
 });
// ===================================== ===================================== 4
gsap.set('.co-gifting-4 .z-ani-o', { opacity: 0, y: 20 });
gsap.to('.co-gifting-4 .z-ani-o', { 
  scrollTrigger: {
    start: 'top 90%',
    end: 'bottom top',
    trigger: '.co-gifting-4'
  },
  y: 0,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
 });
// ===================================== ===================================== 5
gsap.set('.co-gifting-5 .z-ani-o', { opacity: 0, y: 20 });
gsap.to('.co-gifting-5 .z-ani-o', { 
  scrollTrigger: {
    start: 'top 90%',
    end: 'bottom top',
    trigger: '.co-gifting-5'
  },
  y: 0,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
 });
// ===================================== ===================================== 6
gsap.set('.co-gifting-6 .z-ani-o', { opacity: 0, y: 20 });
gsap.to('.co-gifting-6 .z-ani-o', { 
  scrollTrigger: {
    start: 'top 90%',
    end: 'bottom top',
    trigger: '.co-gifting-6'
  },
  y: 0,
  opacity: 1,
  duration: 1,
  stagger: 0.2,
  ease: "power2.inOut"
 });

gsap.to('.co-gifting-6-right-frame img', { 
  scrollTrigger: {
    start: 'top bottom',
    end: 'bottom top',
    trigger: '.co-gifting-6',
    scrub: true
  },
  top: "-10%"
 });

 // ===================================== ===================================== 7
   gsap.set('.co-process-s3-frame .z-ani-o', { opacity: 0, y: 40 });
  let cPS3Tl1 = gsap.timeline({ paused: true });
  cPS3Tl1.to('.co-process-s3-frame .z-ani-o', {
    y: 0,
    scale: 1,
    opacity: 1,
    duration: 1,
    stagger: 0.2,
    ease: "power2.inOut"
  }, "-=0.9");
  ScrollTrigger.create({
    trigger: '.co-process-s3-frame .z-ani-o',
    start: "40% bottom",
    end: "bottom top",
    animation: cPS3Tl1
  });
// ===================================== ===================================== ACCORDION
var coAccItems = document.querySelectorAll(".co-process-s3-item--title");
  var coAccItemsWrapp = document.querySelectorAll(".co-process-s3-item");
  // Hide the next sibling element for each item (the content associated with the title)
  coAccItems.forEach(function (groupItem, index) {
    var nextElement = groupItem.nextElementSibling;
    if (index === 0 || groupItem.classList.contains("active")) {
      groupItem.classList.add("active");
      nextElement.classList.add("active");

      gsap.to(nextElement, {
        height: "auto",
        duration: 0.3,
        ease: "power2.inOut",
      });
    } else {
      nextElement.classList.remove("active");
      gsap.to(nextElement, {
        height: 0,
        duration: 0.3,
        ease: "power2.inOut",
      });
    }

    // Add a click event listener to each item
    groupItem.addEventListener("click", function (e) {
      e.preventDefault();
      // Check if the parent element already has the 'active' class
      if (!this.classList.contains("active")) {
        // If not active, hide all other sections
        // coAccItems.forEach(function (otherAccItem, otherIndex) {
        //   otherAccItem.classList.remove("active");
        //   otherAccItem.nextElementSibling.classList.remove("active");

        //   gsap.to(otherAccItem.nextElementSibling, {
        //     height: 0,
        //     duration: 0.3,
        //     ease: "power2.inOut",
        //   });
        // });
        // Add 'active' class to the clicked item and show its content
        this.classList.add("active");
        nextElement.classList.add("active");
        gsap.to(nextElement, {
          height: "auto",
          duration: 0.3,
          ease: "power2.inOut",
        });
      } else {
        // remove 'active' if clicked on 'active'
        this.classList.remove("active");
        nextElement.classList.remove("active");
        gsap.to(nextElement, {
          height: 0,
          duration: 0.3,
          ease: "power2.inOut",
        });
      }
      // If already active, don't hide the content
    });


  });